import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-ktostamm-kunde-subnummer-detail-view',
  imports: [],
  templateUrl: './ktostamm-kunde-subnummer.detail-view.html',
  styleUrls: ['./ktostamm-kunde-subnummer.detail-view.css'],
})
export class KtostammKundeSubnummerDetailView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
